var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { extractData, getFetchOptions } from "../utils";
import { showModalFromHtml } from "../components/modal";
import EventBus from "../events/EventBus";
let instance;
let channel;
let productsList = new Set();
let brandsList = new Set();
let offlineMode = true;
const LOCAL_STORAGE_NAME = 'favorites';
function initFavorites() {
    const dataEl = document.getElementById('favorites-data');
    if (window.BroadcastChannel) {
        channel = new BroadcastChannel('favorites');
        channel.addEventListener('message', ({ data }) => {
            loadData(data, false);
        });
    }
    if (dataEl) {
        loadData(extractData(dataEl));
        offlineMode = false;
        synchronizeFavorites();
    }
    else {
        offlineMode = true;
        loadData(loadFromLocalStorage());
    }
    return { toggleFavorite, has };
}
export function useFavoritesApi() {
    return instance !== null && instance !== void 0 ? instance : (instance = initFavorites());
}
function toggleFavorite(id, brand) {
    return __awaiter(this, void 0, void 0, function* () {
        const list = brand ? brandsList : productsList;
        let status;
        if (offlineMode) {
            status = !list.has(id);
        }
        else {
            status = yield fetch('/api/favorites/toggle', getFetchOptions({ id, brand }, true))
                .then(response => response.json())
                .then(response => {
                if (response.html) {
                    showModalFromHtml(response.html);
                }
                return response.status;
            });
        }
        if (status) {
            list.add(id);
        }
        else {
            list.delete(id);
        }
        if (offlineMode) {
            saveToLocalStorage();
        }
        notifyChange();
        return status;
    });
}
function synchronizeFavorites() {
    const data = loadFromLocalStorage();
    if (!data.products.length && !data.brands.length) {
        return;
    }
    loadData({
        products: [...productsList, ...data.products],
        brands: [...brandsList, ...data.brands],
    });
    fetch('/api/favorites/sync', getFetchOptions(data, true))
        .then(response => response.json())
        .then(response => response.ok && clearLocalStorage());
}
function has(id, brand) {
    return brand ? brandsList.has(id) : productsList.has(id);
}
function loadData(data, notify = true) {
    var _a, _b;
    const newProductsList = (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [];
    const newBrandsList = (_b = data === null || data === void 0 ? void 0 : data.brands) !== null && _b !== void 0 ? _b : [];
    if (newProductsList === Array.from(productsList) && newBrandsList === Array.from(brandsList)) {
        return;
    }
    productsList = new Set(newProductsList);
    brandsList = new Set(newBrandsList);
    EventBus.emit('favorites:change');
    if (notify) {
        notifyChange();
    }
}
function notifyChange() {
    channel === null || channel === void 0 ? void 0 : channel.postMessage({
        products: Array.from(productsList),
        brands: Array.from(brandsList),
    });
}
function loadFromLocalStorage() {
    var _a, _b;
    const data = JSON.parse(localStorage.getItem('favorites'));
    return {
        products: (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [],
        brands: (_b = data === null || data === void 0 ? void 0 : data.brands) !== null && _b !== void 0 ? _b : [],
    };
}
function saveToLocalStorage() {
    localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify({
        products: Array.from(productsList),
        brands: Array.from(brandsList),
    }));
}
function clearLocalStorage() {
    localStorage.removeItem(LOCAL_STORAGE_NAME);
}
